"use client";
import Button from "@/components/primitives/button";
import Icon from "@/components/primitives/icon";
import styles from "./cell.module.css";
import {
    BettorPickSlipPick,
    GameAlignment,
    GameBasic,
    GameStatus,
    LineType,
    Odd2,
    OddOutcome,
    OddVariant,
    RecentPick,
    isGameClosed,
    isGameException,
    lineToPickType,
    toSportType,
  } from "common";
  import { buildOdd } from "common";
  import { formatOdd } from "@/utils";
  import { useContext, useEffect, useRef, useState } from "react";
  import { PickSlipContext } from "@/utils/providers/pick-slip";
  import { CreatedPickTooltip } from "@/components/primitives/tooltip";
  import { useOddsFormat } from "@/utils/providers/odds-format";

  export type OddCellColor = "default" | "dark" | "light" | "neutral";
export interface OddsCellProps {
  alignment: GameAlignment;
  game: any;
  className?: string;
  color?: OddCellColor;
  hideCheckmark?: boolean;
  hidePickStatus?: boolean;
  odd: Odd2 | undefined;
  againstOdd: Odd2 | undefined;
}

export default function StaticOddsCell(props: OddsCellProps) {
    const { oddsFormat } = useOddsFormat();
  
    const exception: boolean = isGameException(props.game.status);
    const closed: boolean = isGameClosed(props.game.status);
  
    const loss: boolean =
      !exception &&
      props.odd?.outcome !== OddOutcome.Win &&
      closed &&
      !props.hideCheckmark;
    const showCheckmark: boolean =
      !exception &&
      props.odd?.outcome === OddOutcome.Win &&
      closed &&
      !props.hideCheckmark;
  
    const oddNotDefined =
    !props.odd || 
      props.odd.payout === undefined ||
      props.odd.payout === 0 ||
      props.odd.payout === null;
    const disabled =
      props.game.status === "InProgress" ||
      closed ||
      oddNotDefined ||
      props.hidePickStatus;
  
    const formattedOdd = formatOdd(oddsFormat, props.odd);
  
    return (
      <div className="relative">
        <Button
          custom
          disabled={disabled}
          unstyled
          data-color={props.color || "default"}
          data-loss={loss ? "true" : undefined}
          className={`${styles.root} ${props.className}`}
        >
          {oddNotDefined? (
            <div className="w-full text-label-lg-bold text-secondary-600 text-center">
              TBD
            </div>
          ) : (
            <>
              {showCheckmark && <Checkmark />}
              <span className="normal-case tracking-[0.06px]">
                {formattedOdd?.type === LineType.Moneyline
                  ? formattedOdd?.payout
                  : formattedOdd?.value}
              </span>
              <div className={`${styles.payout}`}>
                {props.odd?.type !== LineType.Moneyline &&
                  !isGameClosed(props.game.status) && (
                    <span className="normal-case">
                      {formattedOdd?.type === LineType.Moneyline
                        ? undefined
                        : formattedOdd?.payout}
                    </span>
                  )}
              </div>
            </>
          )}
        </Button>
        {!props.hidePickStatus &&
          props.game.status === "Scheduled" && (
            <CreatedPickTooltip
              position={props.alignment === "away" ? "top" : "bottom"}
            >
              You picked this odd
            </CreatedPickTooltip>
          )}
      </div>
    );
  }


function Checkmark() {
    return (
      <div className="rounded-full bg-primary-300 min-w-[16px] h-4 flex items-center justify-center">
        <Icon name="checkmark" size="xs" className="fill-white" />
      </div>
    );
  }